import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "product-popup__energy-card" }
const _hoisted_2 = { class: "product-popup__energy-card-image" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "product-popup__info-section" }
const _hoisted_6 = { class: "product-popup__product-name" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "green-bar" }, null, -1)
const _hoisted_8 = { class: "product-popup__product-features" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "segmented-button__label" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "product-popup__product-data" }
const _hoisted_14 = { class: "bold" }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "product-popup__product-data-divider" }, null, -1)
const _hoisted_17 = { class: "product-popup__product-data-bottom-section" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "segmented-button__label" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "icons" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createBlock(_component_popup, {
    ref: "popup",
    class: "product-popup"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.product.energyLabelImage,
            alt: _ctx.EnergyLabelAltText
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("a", {
          href: _ctx.product.energyLabelUrl,
          class: "product-popup__energy-card-download-btn",
          target: "_blank",
          download: "",
          rel: "noreferrer"
        }, _toDisplayString(_ctx.$t('heuver-albourgh.components.productSlider.btnDownload')), 9, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.product.productFamily) + " ", 1),
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx.product.name), 1)
        ]),
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.productFeatures, (feature) => {
            return (_openBlock(), _createElementBlock("li", { key: feature }, [
              _createElementVNode("span", { innerHTML: _ctx.TruncatedChevron }, null, 8, _hoisted_9),
              _createTextVNode(" " + _toDisplayString(feature), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("a", {
          class: "product-popup__product-buy-btn segmented-button segmented-button--full segmented-button--green",
          href: _ctx.orderUrl
        }, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("heuver-albourgh.components.productSlider.btnOrder")), 1),
          _createElementVNode("span", {
            class: "segmented-button__icon",
            innerHTML: _ctx.ArrowUp
          }, null, 8, _hoisted_12)
        ], 8, _hoisted_10),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("table", null, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('heuver-albourgh.components.productInformation.table.heading.size')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('heuver-albourgh.components.productInformation.table.heading.lsIndex')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('heuver-albourgh.components.productInformation.table.heading.download')), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.productTableEntries, (row) => {
                return (_openBlock(), _createElementBlock("tr", { key: row }, [
                  _createElementVNode("td", _hoisted_14, _toDisplayString(row.size), 1),
                  _createElementVNode("td", null, _toDisplayString(row.index), 1),
                  _createElementVNode("td", null, [
                    (row.pdfUrl)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: row.pdfUrl
                        }, _toDisplayString(_ctx.$t('heuver-albourgh.components.productInformation.table.body.download')), 9, _hoisted_15))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("a", {
              class: "segmented-button segmented-button--full segmented-button--green",
              href: _ctx.orderUrl
            }, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("heuver-albourgh.components.productSlider.btnOrder")), 1),
              _createElementVNode("span", {
                class: "segmented-button__icon",
                innerHTML: _ctx.ArrowUp
              }, null, 8, _hoisted_20)
            ], 8, _hoisted_18),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", {
                innerHTML: _ctx.getTyreUsageIcon(_ctx.product.firstIcon)
              }, null, 8, _hoisted_22),
              _createElementVNode("span", {
                innerHTML: _ctx.getTyreUsageIcon(_ctx.product.secondIcon)
              }, null, 8, _hoisted_23),
              _createElementVNode("span", {
                innerHTML: _ctx.getTyreUsageIcon(_ctx.product.thirdIcon)
              }, null, 8, _hoisted_24),
              _createElementVNode("span", {
                innerHTML: _ctx.getTyreUsageIcon(_ctx.product.fourthIcon)
              }, null, 8, _hoisted_25),
              _createElementVNode("span", {
                class: "truck-icon",
                innerHTML: _ctx.getIcon()
              }, null, 8, _hoisted_26)
            ])
          ])
        ])
      ]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 512))
}